<div class="container my-5">
  <div class="card shadow">
    <div class="card-body p-5">

      <h1 class="text-center mb-4">
        Privacy Policy for WhatsApp API Integration
      </h1>

      <p><strong>Last Updated:</strong> 2026-02-21</p>

      <hr />

      <h4>1. Introduction</h4>
      <p>
        <strong>s1az.com</strong> respects your privacy and is committed to protecting your personal information.
        This Privacy Policy explains how we collect, use, and protect information when communicating
        through the <strong>WhatsApp Business API</strong>.
      </p>
      <p>
        Our WhatsApp messaging services are powered by the WhatsApp Business API
        provided by Meta Platforms, Inc.
      </p>

      <h4 class="mt-4">2. Information We Collect</h4>
      <p>When you interact with us via WhatsApp, we may collect:</p>
      <ul>
        <li>Your phone number</li>
        <li>Your name (if provided)</li>
        <li>Message content sent and received</li>
        <li>Media files (images, documents, audio) shared during conversation</li>
        <li>Device and usage metadata provided by WhatsApp</li>
      </ul>

      <h4 class="mt-4">3. How We Use Your Information</h4>
      <p>We use your information to:</p>
      <ul>
        <li>Respond to your inquiries</li>
        <li>Provide customer support</li>
        <li>Send transactional messages (invoices, order confirmations, service updates)</li>
        <li>Improve our services</li>
        <li>Comply with legal requirements</li>
      </ul>
      <p>
        We do not sell, rent, or trade your personal information.
      </p>

      <h4 class="mt-4">4. Legal Basis for Processing</h4>
      <p>We process your information based on:</p>
      <ul>
        <li>Your consent when initiating contact</li>
        <li>Contractual necessity (e.g., sending order confirmations)</li>
        <li>Legal obligations</li>
        <li>Legitimate business interests</li>
      </ul>

      <h4 class="mt-4">5. Data Sharing</h4>
      <p>We may share your data with:</p>
      <ul>
        <li>WhatsApp (Meta Platforms, Inc.)</li>
        <li>Our authorized employees or service providers</li>
        <li>Government authorities if legally required</li>
      </ul>
      <p>
        All third-party providers are required to maintain confidentiality and
        data protection standards.
      </p>

      <h4 class="mt-4">6. Data Retention</h4>
      <p>
        We retain WhatsApp communications only as long as necessary for:
      </p>
      <ul>
        <li>Business operations</li>
        <li>Legal compliance</li>
        <li>Dispute resolution</li>
      </ul>
      <p>
        After that, data is securely deleted.
      </p>

      <h4 class="mt-4">7. Data Security</h4>
      <p>
        We implement appropriate technical and organizational measures to protect
        your personal information against unauthorized access, disclosure,
        alteration, or destruction.
      </p>

      <h4 class="mt-4">8. Your Rights</h4>
      <p>Depending on your location, you may have the right to:</p>
      <ul>
        <li>Access your personal data</li>
        <li>Correct inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Withdraw consent</li>
        <li>File a complaint with a data protection authority</li>
      </ul>
      <p>
        To exercise your rights, contact us at:
        <a href="mailto:info@s1az.com">info&#64;s1az.com</a>
      </p>

      <h4 class="mt-4">9. Third-Party Policies</h4>
      <p>
        Your use of WhatsApp is also governed by:
      </p>
      <ul>
        <li>WhatsApp Privacy Policy</li>
        <li>Meta Privacy Policy</li>
      </ul>
      <p>
        We are not responsible for how WhatsApp or Meta processes your data beyond our control.
      </p>

      <h4 class="mt-4">10. Contact Information</h4>
      <p>If you have questions about this Privacy Policy, please contact:</p>

      <p>
        <strong>s1az.com</strong><br />
        Address: 227, East Rampura, Dhaka, 1219, Bangladesh<br />
        Email: <a href="mailto:info@s1az.com">info&#64;s1az.com</a><br />
        Phone: <a href="tel:+8801706088146">+8801706088146</a>
      </p>

    </div>
  </div>
</div>
